var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"hide-default-header":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('tr',[_c('td',{attrs:{"colspan":"7"}},[_c('label-component',{attrs:{"horizontal":"left"}},[_vm._v("■この契約の関係者")])],1)])]},proxy:true},{key:"item.sn",fn:function(ref){
var index = ref.index;
var item = ref.item;
return [_c('v-avatar',{attrs:{"size":30,"color":"grey lighten-1"}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }